export type PainelChave =
  | "equipe"
  | "pacientes"
  | "agenda"
  | "protese"
  | "pendentes"
  | "producao"
  | "atrasados"
  | "resumo";

/** Página da organização que corresponde a cada painel — destino do "Abrir em". */
export const PAGINA_DO_PAINEL: Record<PainelChave, string> = {
  equipe: "/equipe",
  pacientes: "/pacientes",
  agenda: "/agenda",
  protese: "/protese",
  pendentes: "/lab/pedidos",
  producao: "/lab/producao",
  atrasados: "/lab/producao",
  resumo: "/inicio",
};
